
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";

interface UserRecord {
  id: string;
  email: string;
  created_at: string;
  last_sign_in_at: string;
  raw_user_meta_data: {
    avatar_url?: string;
    email?: string;
    full_name?: string;
    iss?: string;
    name?: string;
    picture?: string;
    provider_id?: string;
  };
}

interface UsersTableProps {
  users: UserRecord[];
}

export const UsersTable = ({ users }: UsersTableProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>User Signups</CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>User</TableHead>
              <TableHead>Email</TableHead>
              <TableHead>Signup Date</TableHead>
              <TableHead>Last Sign In</TableHead>
              <TableHead>Provider</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {users.map((user) => (
              <TableRow key={user.id}>
                <TableCell>
                  <div className="flex items-center space-x-3">
                    <Avatar>
                      <AvatarImage src={user.raw_user_meta_data.avatar_url || user.raw_user_meta_data.picture} />
                      <AvatarFallback>
                        {(user.raw_user_meta_data.full_name || user.raw_user_meta_data.name || user.email)
                          .split(' ')
                          .map(n => n[0])
                          .join('')
                          .toUpperCase()}
                      </AvatarFallback>
                    </Avatar>
                    <span>{user.raw_user_meta_data.full_name || user.raw_user_meta_data.name}</span>
                  </div>
                </TableCell>
                <TableCell>{user.email}</TableCell>
                <TableCell>{new Date(user.created_at).toLocaleString()}</TableCell>
                <TableCell>{new Date(user.last_sign_in_at).toLocaleString()}</TableCell>
                <TableCell>
                  <span className="px-2 py-1 rounded-full text-sm bg-purple-100 text-purple-800">
                    Google
                  </span>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};
